export default "__VITE_PUBLIC_ASSET__676f45ad__"